import React from "react";
import { Popup } from "devextreme-react/popup";
import DataGrid, { Column } from "devextreme-react/data-grid";
import SelectBox from "devextreme-react/select-box";

const GCRRebateOptimizerTool = ({
  TotalRXSpend = 1,
  TotalRxSpendNew = 2,
  ChangeInSpend = 3,
  TotalBrandRxSpend = 4,
  TotalBrandRxSpendNew = 5,
  ChangeInBrandSpend = 6,
  BrandRebateSpend = 7,
  BrandRebateSpendNew = 8,
  ChangeInBrandRebateSpend = 9,
  TotalGenericRxSpend = 0,
  TotalGenericRxSpendNew = 1,
  ChangeInGenericSpend = 2,
  GenericRebateSpend = 3,
  GenericRebateSpendNew = 4,
  ChangeInGenericRebateSpend = 5,
  ComplianceRate = 0.06,
  dataSourceGCRPercentSelections = [
    { id: 1, Name: "Option 1" },
    { id: 2, Name: "Option 2" },
    { id: 3, Name: "Option 3" },
  ],
  GCRPercentSelection = "Option 1", // Default selection
  onComplianceRateChanged = () => {}, // Dummy function
  ChangeInGCRPercent = 0,
  EstimatedCurrentRebate = 1,
  EstimatedCurrentRebateNew = 2,
  ChangeInEstimatedRebate = 3,
  visible,
  onHide,
}) => {
  const tableData = [
    {
      description: "RX Spend",
      current: TotalRXSpend,
      estimate: TotalRxSpendNew,
      change: ChangeInSpend,
    },
    {
      description: "Brand RX Spend",
      current: TotalBrandRxSpend,
      estimate: TotalBrandRxSpendNew,
      change: ChangeInBrandSpend,
    },
    {
      description: "Rebateable Brand",
      current: BrandRebateSpend,
      estimate: BrandRebateSpendNew,
      change: ChangeInBrandRebateSpend,
    },
    {
      description: "Generic RX Spend",
      current: TotalGenericRxSpend,
      estimate: TotalGenericRxSpendNew,
      change: ChangeInGenericSpend,
    },
    {
      description: "Rebateable Generic",
      current: GenericRebateSpend,
      estimate: GenericRebateSpendNew,
      change: ChangeInGenericRebateSpend,
    },
    {
      description: "GCR %",
      current: ComplianceRate,
      estimate: GCRPercentSelection,
      change: ChangeInGCRPercent,
    },
    {
      description: "Rebate",
      current: EstimatedCurrentRebate,
      estimate: EstimatedCurrentRebateNew,
      change: ChangeInEstimatedRebate,
    },
  ];

  return (
    <Popup
      visible={visible}
      onHiding={onHide}
      width={700}
      height={600}
      showTitle={true}
      title="GCR Rebate Optimizer Tool"
      dragEnabled={false}
      showCloseButton={true}
      closeOnOutsideClick={true}
    >
      <div>
        <DataGrid
          dataSource={tableData}
          columnAutoWidth={true}
          showBorders={true}
        >
          <Column
            className="cell-content"
            dataField="description"
            caption="Description"
            cellRender={(data) => (
              <div className="cell-content">{data.value}</div>
            )}
          />
          <Column
            className="cell-content"
            dataField="current"
            headerCellRender={() => (
              <div className="header-cell-current">Current</div>
            )}
            cellRender={(data) => (
              <div className="cell-content">{data.value}</div>
            )}
          />
          <Column
            className="cell-content"
            dataField="estimate"
            headerCellRender={() => (
              <div className="header-cell-current">Estimate</div>
            )}
            cellRender={(data) =>
              data.column.dataField === "estimate" &&
              data.data.description === "GCR %" ? (
                <SelectBox
                  dataSource={dataSourceGCRPercentSelections}
                  value={GCRPercentSelection}
                  displayExpr="Name"
                  valueExpr="Name"
                  onValueChanged={onComplianceRateChanged}
                  className="select-box-small"
                />
              ) : (
                <div className="cell-content">{data.value}</div>
              )
            }
          />
          <Column
            className="cell-content"
            dataField="change"
            caption="Change"
            cellRender={(data) => (
              <div className="cell-content">{data.value}</div>
            )}
          />
        </DataGrid>
      </div>
    </Popup>
  );
};

export default GCRRebateOptimizerTool;
